(() => {
  const ROOT_ATTR = 'data-pms';
  const READY_ATTR = 'data-pms-ready';
  const MOTION_ATTR = 'data-pms-motion';
  const RETRY_MS = 80;
  const RETRY_MAX = 40;
  const COLS = 52;
  const ROWS = 16;
  const CELL = 4;
  const ANGLE_MIN = -58;
  const ANGLE_MAX = 58;

  const FRAME_COLORS = {
    W: '#f4f4f2',
    G: '#4c4c4c',
    B: '#37a42f',
    U: '#199be7',
    C: '#19e7c8',
    V: '#904cff',
    L: '#9be719',
    R: '#e71f19',
    O: '#e77619',
    Y: '#ffd334',
    S: '#ffce64',
    A: '#3ab8fe'
  };

  const MODE_FRAMES = [
    [
      '....................................................',
      '....................................................',
      '....................................................',
      '.........WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW...........',
      '........WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW..........',
      '........WW..BBBBB..BBBBB..BBBBB..BBBBB..WW..........',
      '........WW..BBBBB..BBBBB..BBBBB..BBBBB..WWGG........',
      '........WW..BBBBB..BBBBB..BBBBB..BBBBB..WWGG........',
      '........WW..BBBBB..BBBBB..BBBBB..BBBBB..WWGG........',
      '........WW..BBBBB..BBBBB..BBBBB..BBBBB..WWGG........',
      '........WW..BBBBB..BBBBB..BBBBB..BBBBB..WW..........',
      '........WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW..........',
      '.........WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW...........',
      '....................................................',
      '....................................................',
      '....................................................'
    ],
    [
      '....................................................',
      '....................VV..............................',
      '....................VV..............................',
      '....................UU..............................',
      '....................UU..............................',
      '........CC.......CC.CC..........CC.............CC...',
      '........CC.......CC.CC..........CC.............CC...',
      '..LL....LL.......LL.LL..........LL.............LL...',
      '..LL.LL.LL....LL.LL.LL.LL.......LL..........LL.LL...',
      '..YY.YY.YY....YY.YY.YY.YY....YY.YY.YY.......YY.YY...',
      '..YY.YY.YY....YY.YY.YY.YY....YY.YY.YY.......YY.YY...',
      '..OO.OO.OO.OO.OO.OO.OO.OO....OO.OO.OO.OO....OO.OO...',
      '..OO.OO.OO.OO.OO.OO.OO.OO....OO.OO.OO.OO....OO.OO...',
      '..RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR...',
      '..RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR.RR...',
      '....................................................'
    ],
    [
      '....................................................',
      '....................................................',
      '....................................................',
      '...RRRRRRRRRRRRRRRRR...WW.WW.WWWWW....WWWWW.WWWWW...',
      '..RRRRRRRRRRRRRRRRRRR..WW.WW.WWWWW....WWWWW.WWWWW...',
      '..RRWWWRWRWRWWWRWRWRR..WW.WW.WW....WW.WW.WW.WW.WW...',
      '..RRWRWRWRWRWRRRWRWRR..WW.WW.WW....WW.WW.WW.WW.WW...',
      '..RRWWRRWRWRWWWRWWWRR..WWWWW.WWWWW....WW.WW.WW.WW...',
      '..RRWRWRWRWRRRWRRWRRR..WWWWW.WWWWW....WW.WW.WW.WW...',
      '..RRWWWRWWWRWWWRRWRRR.....WW....WW.WW.WW.WW.WW.WW...',
      '..RRRRRRRRRRRRRRRRRRR.....WW....WW.WW.WW.WW.WW.WW...',
      '...RRRRRRRRRRRRRRRRR......WW.WWWWW....WWWWW.WWWWW...',
      '....GGGGGGGGGGGGGGG.......WW.WWWWW....WWWWW.WWWWW...',
      '....................................................',
      '....................................................',
      '....................................................'
    ],
    [
      '....................................................',
      '....................................................',
      '...................................W................',
      '.....S..S...........WWWWWW.WWWWWW....WWWW...........',
      '...S......S.........WWWWWW.WWWWWW...WWWWWW..........',
      '.....SSSS...............WW.WW.......WW..WW..........',
      '....SSSSSS..............WW.WW.......WW..............',
      '..S.SSSSSS.S........WWWWWW.WWWWWW...WW..............',
      '....SSSSSS..........WWWWWW.WWWWWW...WW..............',
      '..S.SSSSSS.S........WW.....WW..WW...WW..............',
      '.....SSSS...........WW.....WW..WW...WW..WW..........',
      '...S......S.........WWWWWW.WWWWWW...WWWWWW..........',
      '.....S..S...........WWWWWW.WWWWWW....WWWW...........',
      '....................................................',
      '....................................................',
      '....................................................'
    ],
    [
      '....................................................',
      '....................................................',
      '....................................................',
      '.....RRRRR.RRRRR.RRRRR.......AAAAA.AAAAA.AAAAA......',
      '.....RRRRR.RRRRR.RRRRR.......AAAAA.AAAAA.AAAAA......',
      '.....RR.RR.RR.RR.RR.RR.......AA.AA.AA.AA.AA.AA......',
      '.....RR.RR.RR.RR.RR.RR.......AA.AA.AA.AA.AA.AA......',
      '.....RR.RR.RR.RR.RR.RR..WWW..AA.AA.AA.AA.AA.AA......',
      '.....RR.RR.RR.RR.RR.RR..WWW..AA.AA.AA.AA.AA.AA......',
      '.....RR.RR.RR.RR.RR.RR.......AA.AA.AA.AA.AA.AA......',
      '.....RR.RR.RR.RR.RR.RR.......AA.AA.AA.AA.AA.AA......',
      '.....RRRRR.RRRRR.RRRRR.......AAAAA.AAAAA.AAAAA......',
      '.....RRRRR.RRRRR.RRRRR.......AAAAA.AAAAA.AAAAA......',
      '....................................................',
      '....................................................',
      '....................................................'
    ]
  ];

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const angleForIndex = (index, count) => {
    if (count <= 1) return 0;
    return ANGLE_MIN + ((ANGLE_MAX - ANGLE_MIN) * index) / (count - 1);
  };

  const initSwitcher = (root) => {
    if (!root) return;
    if (typeof root._pmsCleanup === 'function') root._pmsCleanup();
    root.setAttribute(READY_ATTR, '');

    const knob = root.querySelector('[data-pms-knob]');
    const pointerRotor = root.querySelector('[data-pms-pointer-rotor]');
    const board = root.querySelector('[data-pms-board]');
    const ctx = board && board.getContext ? board.getContext('2d') : null;
    const tabs = Array.from(root.querySelectorAll('[data-pms-tab]'));
    const images = Array.from(root.querySelectorAll('[data-pms-image]'));
    if (!tabs.length) return;

    const count = tabs.length;
    const angles = tabs.map((_, i) => angleForIndex(i, count));
    let index = Math.max(
      0,
      tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
    );
    if (index < 0) index = 0;

    let dragging = false;
    let dragMoved = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartMode = 0;

    const paintPixel = (column, row, color) => {
      if (!ctx || column < 0 || column >= COLS || row < 0 || row >= ROWS) return;
      ctx.fillStyle = color;
      ctx.fillRect(column * CELL + 1, row * CELL + 1, CELL - 1, CELL - 1);
    };

    const drawFrame = (frameIndex) => {
      if (!ctx || !board) return;
      ctx.fillStyle = '#101010';
      ctx.fillRect(0, 0, board.width, board.height);
      for (let row = 0; row < ROWS; row += 1) {
        for (let column = 0; column < COLS; column += 1) {
          paintPixel(column, row, 'rgba(255, 255, 255, 0.025)');
        }
      }
      const frame = MODE_FRAMES[frameIndex % MODE_FRAMES.length];
      frame.forEach((rowPattern, rowIndex) => {
        Array.from(rowPattern).forEach((symbol, columnIndex) => {
          if (symbol === '.') return;
          paintPixel(columnIndex, rowIndex, FRAME_COLORS[symbol] || '#f4f4f2');
        });
      });
    };

    const apply = (nextIndex, { focusTab = false, snapPointer = true } = {}) => {
      const tab = tabs[nextIndex];
      if (!tab) return;
      index = nextIndex;

      tabs.forEach((item, i) => {
        const selected = i === index;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      images.forEach((img, i) => {
        img.classList.toggle('is-active', i === index);
      });

      if (snapPointer) {
        pointerRotor?.style.setProperty('--pms-knob-angle', `${angles[index]}deg`);
      }
      knob?.setAttribute('aria-valuenow', String(index));
      knob?.setAttribute('aria-valuetext', tab.textContent.trim());
      if (board) board.setAttribute('aria-label', tab.textContent.trim());
      if (focusTab) tab.focus();
      drawFrame(index);
    };

    const getPointerAngle = (event) => {
      if (!knob) return angles[index];
      const bounds = knob.getBoundingClientRect();
      const x = event.clientX - (bounds.left + bounds.width / 2);
      const y = event.clientY - (bounds.top + bounds.height / 2);
      return Math.max(ANGLE_MIN, Math.min(ANGLE_MAX, (Math.atan2(y, x) * 180) / Math.PI + 90));
    };

    const nearestIndex = (angle) =>
      angles.reduce(
        (nearest, target, i) =>
          Math.abs(target - angle) < Math.abs(angles[nearest] - angle) ? i : nearest,
        0
      );

    const onClick = (event) => {
      const next = tabs.indexOf(event.currentTarget);
      if (next < 0 || next === index) return;
      apply(next);
    };

    const onKeydown = (event) => {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next =
        event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? count - 1
            : (index + (event.key === 'ArrowRight' ? 1 : -1) + count) % count;
      apply(next, { focusTab: true });
    };

    const onKnobPointerDown = (event) => {
      if (event.button !== 0) return;
      dragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragStartMode = index;
      knob.classList.add('is-dragging');
      knob.setPointerCapture(event.pointerId);
    };

    const onKnobPointerMove = (event) => {
      if (!dragging) return;
      if (Math.hypot(event.clientX - dragStartX, event.clientY - dragStartY) > 4) dragMoved = true;
      if (!dragMoved) return;
      const angle = getPointerAngle(event);
      const next = nearestIndex(angle);
      if (next !== index) apply(next, { snapPointer: false });
      pointerRotor?.style.setProperty('--pms-knob-angle', `${angle}deg`);
    };

    const onKnobPointerUp = (event) => {
      if (!dragging) return;
      dragging = false;
      knob.classList.remove('is-dragging');
      if (knob.hasPointerCapture(event.pointerId)) knob.releasePointerCapture(event.pointerId);
      if (event.type === 'pointercancel') apply(dragStartMode);
      else if (dragMoved) apply(nearestIndex(getPointerAngle(event)));
      else apply((dragStartMode + 1) % count);
    };

    const onKnobWheel = (event) => {
      event.preventDefault();
      apply((index + (event.deltaY > 0 ? 1 : -1) + count) % count);
    };

    const onKnobKeydown = (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) {
        return;
      }
      event.preventDefault();
      if (event.key === 'Home') apply(0);
      else if (event.key === 'End') apply(count - 1);
      else {
        apply(
          (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + count) % count
        );
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', onClick);
      tab.addEventListener('keydown', onKeydown);
    });

    if (knob) {
      knob.addEventListener('pointerdown', onKnobPointerDown);
      knob.addEventListener('pointermove', onKnobPointerMove);
      knob.addEventListener('pointerup', onKnobPointerUp);
      knob.addEventListener('pointercancel', onKnobPointerUp);
      knob.addEventListener('wheel', onKnobWheel, { passive: false });
      knob.addEventListener('keydown', onKnobKeydown);
    }

    root._pmsApply = apply;
    root._pmsNearest = nearestIndex;
    root._pmsAngles = angles;

    root._pmsCleanup = () => {
      tabs.forEach((tab) => {
        tab.removeEventListener('click', onClick);
        tab.removeEventListener('keydown', onKeydown);
      });
      if (knob) {
        knob.removeEventListener('pointerdown', onKnobPointerDown);
        knob.removeEventListener('pointermove', onKnobPointerMove);
        knob.removeEventListener('pointerup', onKnobPointerUp);
        knob.removeEventListener('pointercancel', onKnobPointerUp);
        knob.removeEventListener('wheel', onKnobWheel);
        knob.removeEventListener('keydown', onKnobKeydown);
      }
      root._pmsApply = null;
      root._pmsNearest = null;
      root._pmsAngles = null;
      root._pmsCleanup = null;
      root.removeAttribute(READY_ATTR);
    };

    apply(index);
  };

  const destroyMotion = (root) => {
    if (!root) return;
    if (root._pmsRetry) {
      clearTimeout(root._pmsRetry);
      root._pmsRetry = null;
    }
    if (root._pmsCtx) {
      root._pmsCtx.revert();
      root._pmsCtx = null;
    }
    root.classList.remove('is-touring');
    root.removeAttribute(MOTION_ATTR);
  };

  const setupMotion = (root, attempt) => {
    if (!root || root.hasAttribute(MOTION_ATTR)) return;
    if (root.getAttribute('data-pms-scroll-motion') !== 'true') return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if ((attempt || 0) < RETRY_MAX) {
        root._pmsRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
      }
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    root.setAttribute(MOTION_ATTR, '');

    const copyItems = root.querySelectorAll('[data-pms-copy-item]');
    const rotor = root.querySelector('[data-pms-pointer-rotor]');
    const angles = root._pmsAngles || [];
    const applyMode = root._pmsApply;
    const nearest = root._pmsNearest;
    const reduced = prefersReducedMotion();

    if (reduced) {
      if (typeof applyMode === 'function') applyMode(0);
      return;
    }

    if (!copyItems.length && !rotor) return;

    root._pmsCtx = gsap.context(() => {
      if (copyItems.length) gsap.set(copyItems, { autoAlpha: 0, y: 16 });

      const far = Math.min(Math.max(angles.length - 1, 0), 2);
      const startAngle = (angles[0] ?? ANGLE_MIN) - 20;
      const farAngle = angles[far] ?? ANGLE_MIN;
      const restAngle = angles[0] ?? ANGLE_MIN;
      const proxy = { a: startAngle };
      let lastMode = -1;

      const tick = () => {
        if (rotor) rotor.style.setProperty('--pms-knob-angle', `${proxy.a}deg`);
        if (typeof nearest !== 'function' || typeof applyMode !== 'function') return;
        const next = nearest(proxy.a);
        if (next === lastMode) return;
        lastMode = next;
        applyMode(next, { snapPointer: false });
      };

      if (rotor) rotor.style.setProperty('--pms-knob-angle', `${startAngle}deg`);
      root.classList.add('is-touring');
      tick();

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: 'top 78%',
          once: true,
          toggleActions: 'play none none none'
        },
        onComplete: () => {
          if (typeof applyMode === 'function') applyMode(0);
          root.classList.remove('is-touring');
        }
      });

      tl.to(proxy, {
        a: farAngle,
        duration: 0.85 + far * 0.18,
        ease: 'power2.inOut',
        onUpdate: tick
      }, 0.12);

      if (far !== 0) {
        tl.to(proxy, {
          a: restAngle,
          duration: 0.7,
          ease: 'power2.inOut',
          onUpdate: tick
        }, '+=0.16');
      }

      if (copyItems.length) {
        tl.to(
          copyItems,
          { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.08, ease: 'power3.out' },
          0
        );
      }
    }, root);
  };

  const scan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => {
      initSwitcher(root);
      setupMotion(root, 0);
    });
  };

  const rescan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => {
      destroyMotion(root);
      if (typeof root._pmsCleanup === 'function') root._pmsCleanup();
    });
    scan();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(`[${ROOT_ATTR}]`);
    if (!root) return;
    destroyMotion(root);
    if (typeof root._pmsCleanup === 'function') root._pmsCleanup();
  });
})();
